import { useEffect } from 'react';

const SeoHead = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImageUrl,
  ogType = 'article',
}) => {
  useEffect(() => {
    // Default Fallbacks
    const defaultTitle = 'Vedic Surgery Portal | Ayush Care & Surgical Knowledge';
    const defaultDesc = 'Comprehensive Ayush Care, Sushruta Samhita, Shalya Tantra textbook chapters and surgical publications.';
    const siteUrl = window.location.origin;
    const currentPath = window.location.pathname;

    const pageTitle = title ? `${title} | Vedic Surgery Portal` : defaultTitle;
    const pageDesc = description || defaultDesc;
    const pageCanonical = canonicalUrl || `${siteUrl}${currentPath}`;
    const pageOgImage = ogImageUrl || `${siteUrl}/og-default.jpg`;

    // 1. Update Title
    document.title = pageTitle;

    // Helper to update or create meta tag
    const updateMetaTag = (selector, attributeName, attributeValue, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attributeName, attributeValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Helper to update or create link tag
    const updateLinkTag = (rel, href) => {
      let element = document.querySelector(`link[rel="${rel}"]`);
      if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
      }
      element.setAttribute('href', href);
    };

    // 2. Meta Description & Keywords
    updateMetaTag('meta[name="description"]', 'name', 'description', pageDesc);
    if (keywords) {
      updateMetaTag('meta[name="keywords"]', 'name', 'keywords', keywords);
    }

    // 3. Open Graph Tags
    updateMetaTag('meta[property="og:title"]', 'property', 'og:title', pageTitle);
    updateMetaTag('meta[property="og:description"]', 'property', 'og:description', pageDesc);
    updateMetaTag('meta[property="og:type"]', 'property', 'og:type', ogType);
    updateMetaTag('meta[property="og:url"]', 'property', 'og:url', pageCanonical);
    updateMetaTag('meta[property="og:image"]', 'property', 'og:image', pageOgImage);

    // 4. Twitter Card
    updateMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    updateMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', pageTitle);
    updateMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', pageDesc);
    updateMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', pageOgImage);

    // 5. Canonical Link
    updateLinkTag('canonical', pageCanonical);
  }, [title, description, keywords, canonicalUrl, ogImageUrl, ogType]);

  return null;
};

export default SeoHead;
